<div class="ui basic segment max-width" [class.loading]="isLoading">
    <app-header title="{{ 'time-off-v3.editWorkSchedule' | translate }}" [back]="true"></app-header>
    <div class="ui segment">
        <app-segment-header title="{{ 'time-off-v3.overallSettings' | translate }}"></app-segment-header>
        <app-work-schedule-overall-settings-form
            (loading)="isLoading = $event"
            [workSchedule]="workSchedule"
        ></app-work-schedule-overall-settings-form>
    </div>
    <!--Holidays Table-->
    <app-holidays-form [workSchedule]="workSchedule"></app-holidays-form>
    <!--Blackout Periods Table-->
    <app-blackout-periods-form [workSchedule]="workSchedule"></app-blackout-periods-form>
</div>
